import React, {Component} from 'react';
import {PartnersCarousel} from '../../components';
import CNBC from '../../assets/cnbc.png';
import CNN from '../../assets/cnn.png';
import Forbes from '../../assets/forbes.png';
import Bella from '../../assets/bella.png';
import LSETF from '../../assets/lsetf.png';
import MWC from '../../assets/mwc.png';
import Guardian from '../../assets/guardian.png';
import './partners.css';

class Partners extends Component {
    render(){
        const partnersImages = [
            {
                name: "Hello",
                imgSrc: CNBC,
                url: "#hello",

            },
            {
                name: "CNN",
                imgSrc: CNN,
                url: "#hello",

            },

            {
                name: "Forbes",
                imgSrc: Forbes,
                url: "#hello",

            },

            {
                name: "Bella Naija",
                imgSrc: Bella,
                url: "#hello",

            },

            {
                name: "LSETF",
                imgSrc: LSETF,
                url: "#hello",

            },

            {
                name: "MWC",
                imgSrc: MWC,
                url: "#hello",

            },

            {
                name: "The Guardian",
                imgSrc: Guardian,
                url: "#hello",

            },
        ];

        return (
        <div className='gmc__partners section__padding'>
            <p className='section__subtitle'>Greymate Care press and partners</p>
            <h2>Don&rsquo;t take our word for it. <br/>These brands swear we&rsquo;re great</h2>
            <div className='gmc__partners-images'>
                <PartnersCarousel partners={partnersImages}/>
            </div>
        </div>
    );
    }
}

export default Partners